import { render } from "./vnewFansCount.vue?vue&type=template&id=7dbf0f8a&scoped=true"
import script from "./vnewFansCount.vue?vue&type=script&lang=js"
export * from "./vnewFansCount.vue?vue&type=script&lang=js"

import "./vnewFansCount.vue?vue&type=style&index=0&id=7dbf0f8a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbf0f8a"]])

export default __exports__